/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import 'app/scripts/views/internal/data-transfer/DragDropEvents';

import Promise from 'bluebird';
// @ts-expect-error TS(7016): Could not find a declaration file for module 'prom... Remove this comment to see the full error message
import Queue from 'promise-queue';
import _ from 'underscore';

import { Analytics, Apdex, tracingCallback } from '@trello/atlassian-analytics';
import { isTouch } from '@trello/browser';
import { renderComponent } from '@trello/component-wrapper';
import { forTemplate } from '@trello/i18n';
import { CardIdProvider } from '@trello/id-context';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import {
  getKey,
  Key,
  registerShortcutHandler,
  Scope,
  unregisterShortcutHandler,
} from '@trello/keybindings';
import { formatLabelColor } from '@trello/labels/formatLabelColor';
import { getScreenFromUrl } from '@trello/marketing-screens';
import { showFlag } from '@trello/nachos/experimental-flags';
import ReactDOM from '@trello/react-dom-wrapper';
import { getRouteIdFromPathname, RouteId } from '@trello/router';
import { navigate } from '@trello/router/navigate';
import { TrelloStorage } from '@trello/storage';
import { safe } from '@trello/strings';
import { CardFrontTestIds } from '@trello/test-ids';

// eslint-disable-next-line no-restricted-imports
import { Controller } from 'app/scripts/controller';
import { getCardUrl } from 'app/scripts/controller/urls';
import { Auth } from 'app/scripts/db/Auth';
import { Dates } from 'app/scripts/lib/dates';
import { repeatAction, undoAction } from 'app/scripts/lib/last-action';
import { isOverLimit } from 'app/scripts/lib/limits';
import { Util } from 'app/scripts/lib/util';
import type { Card, CardAttributes } from 'app/scripts/models/Card';
import type { MemberAttributes } from 'app/scripts/models/Member';
import { CardMemberSelectView } from 'app/scripts/views/card/CardMemberSelectView';
import { CardViewHelpers } from 'app/scripts/views/card/CardViewHelpers';
import { PasteInput } from 'app/scripts/views/internal/PasteInput';
import { pluginsChangedSignal } from 'app/scripts/views/internal/plugins/PluginsChangedSignal';
import type { ViewOptions } from 'app/scripts/views/internal/View';
import { View } from 'app/scripts/views/internal/View';
import { LabelKeyHelper } from 'app/scripts/views/label/LabelKeyHelper';
import { DragSort } from 'app/scripts/views/lib/DragSort';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { CardInListTemplate } from 'app/scripts/views/templates/CardInListTemplate';
import { isBoardControllerRefactorEnabled } from 'app/src/components/Board/isBoardControllerRefactorEnabled';
import { BoardCard } from 'app/src/components/CardFront/BoardCard';
import { LazyLinkCard } from 'app/src/components/CardFront/LazyLinkCard';
import { SeparatorCard } from 'app/src/components/CardFront/SeparatorCard';
import { LazyCardDateRangePicker } from 'app/src/components/DateRangePicker/LazyCardDateRangePicker';
import { toggleLabelsPopover } from 'app/src/components/LabelsPopover';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { dragenter, dragleave, dropFiles, dropUrl } from './CardViewAttachment';
import { showCover } from './CardViewCover';
import { moveIn, moveTo } from './CardViewLists';
import {
  clearColorCover,
  clearCover,
  clearFullCover,
  getBadgesHtml,
  getFullCoverStylesForInitialRender,
  labelsData,
  removeNotificationIconBadge,
  removeSubscribedIconBadge,
  renderBadges,
  renderCover,
  renderFullCover,
  renderLabels,
  renderMembers,
  renderPluginCover,
  toggleDueDateComplete,
  updateBadges,
  updateCheckItemsEarliestDue,
  updateDateBadges,
  updateDueDate,
} from './CardViewMixins';
import { openQuickCardEditor, renderName } from './CardViewNameEdit';
import {
  addNewStickerToList,
  moveInCalendarDay,
  moveToCalendarDay,
  renderCustomFieldItems,
  renderDueComplete,
  renderPluginBadges,
  renderPowerUpEffects,
  renderStickers,
  showStickers,
} from './CardViewPlugins';
import { isOnBoardTemplate } from './CardViewTemplates';

// eslint-disable-next-line @trello/no-module-logic
const HOOK_DROPPABLE_QUEUE = new Queue(1);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const enqueueDroppable = function (cardView: any) {
  HOOK_DROPPABLE_QUEUE.add(
    () =>
      new Promise(function (resolve) {
        cardView.hookDroppable();
        _.defer(resolve);
      }),
  );
};

/**
 * This debounce ensures that we dont call refresh sortables
 * as we drag cards down a long list, which is expensive. Instead
 * we enqueue a timeout and run this when we are no longer scrolling
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const enqueueRefreshSortable = _.debounce((cardView: any) => {
  DragSort.refreshListCardSortable();
  DragSort.refreshIfInitialized(DragSort.$target);
}, 200);

const format = forTemplate('due_date_picker');
const formatShortcuts = forTemplate('shortcuts');

const INVALID_SHORTCUTS_FOR_CARDS_WITH_ROLE = [
  'l',
  '-',
  'd',
  'a',
  'm',
  'v',
  's',
  ' ',
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
];

interface CardView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _droppableHookedSinceRender: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _visible: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  addNewStickerToList: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  advancedChecklistsV2Enabled: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  applyBoardCardFilter: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getFullCoverStylesForInitialRender: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  hasRenderedFull: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isObserving: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isOnBoardTemplate: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  labelsData: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  lazyRenderCard: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  observer: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onCalendar: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openQuickCardEditor: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  removeNotificationIconBadge: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  removeSubscribedIconBadge: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderBadges: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderBadgesDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderCover: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderCoverDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderCustomFieldItems: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderCustomFieldItemsDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderDueComplete: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderFilteredDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderLabels: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderMembers: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderName: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderNameDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderPluginBadges: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderPowerUpEffects: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderPowerUpEffectsDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderStickers: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderStickersDebounced: any;
  showCover: () => boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  throttle: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  throttledClose: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  throttledJoin: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  throttledMoveToNextList: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  throttledMoveToPrevList: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  throttledSubscribe: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  throttledVote: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  trackApdex: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  trigger: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  unmountReactCard: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateBadgesDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateDateBadgesDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  waitForId: any;
}

interface CardViewOptions extends ViewOptions {
  hideMenu: boolean;
}

class CardView extends View<Card, CardViewOptions> {
  static initClass() {
    // @ts-expect-error TS(2322): Type '() => "a" | "div"' is not assignable to type... Remove this comment to see the full error message
    this.prototype.tagName = function () {
      return this.model.getCardRole() ? 'div' : 'a';
    };

    // @ts-expect-error TS(2339): Property 'filterDeactivated' does not exist on typ... Remove this comment to see the full error message
    this.prototype.filterDeactivated = true;
    this.prototype.applyBoardCardFilter = true;
    this.prototype.trackApdex = true;

    this.prototype.events = {
      // @ts-expect-error TS(2322): Type '{ moveto: string; movein: string; moveToCale... Remove this comment to see the full error message
      moveto: 'moveTo',
      movein: 'moveIn',

      moveToCalendarDay: 'moveToCalendarDay',
      moveInCalendarDay: 'moveInCalendarDay',

      'click .js-open-quick-card-editor': 'openQuickCardEditor',
      'click .js-member-on-card-menu': 'openMemberOnCardMenu',
      'click .js-due-date-badge': 'toggleDueDateComplete',
      click: 'handleClick',

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      contextmenu(e: any) {
        // If they've got a modifier key pressed, maybe they're trying to get at the
        // system version of the context menu.  Also let developers opt out of it
        // completely with a localStorage key
        if (
          e.ctrlKey ||
          e.metaKey ||
          e.shiftKey ||
          TrelloStorage.get('nocontext')
        ) {
          return;
        }

        // @ts-expect-error TS(2339): Property 'openQuickCardEditor' does not exist on t... Remove this comment to see the full error message
        return this.openQuickCardEditor(e);
      },

      mouseenter() {
        // @ts-expect-error TS(2339): Property 'trigger' does not exist on type '() => {... Remove this comment to see the full error message
        return this.trigger('mouseEnterCardView');
      },
      mousemove() {
        // @ts-expect-error TS(2339): Property 'trigger' does not exist on type '() => {... Remove this comment to see the full error message
        return this.trigger('mouseMoveCardView');
      },
      mouseleave() {
        // @ts-expect-error TS(2339): Property 'trigger' does not exist on type '() => {... Remove this comment to see the full error message
        return this.trigger('mouseLeaveCardView');
      },

      'dd-enter:files': 'dragenter',
      'dd-leave:files': 'dragleave',
      'dd-drop:files': 'dropFiles',
      'dd-enter:url': 'dragenter',
      'dd-leave:url': 'dragleave',
      'dd-drop:url': 'dropUrl',

      'pasteinput:files': 'dropFiles',
      'pasteinput:url': 'dropUrl',
    };

    // @ts-expect-error TS(2339): Property 'clearCover' does not exist on type 'Card... Remove this comment to see the full error message
    this.prototype.clearCover = clearCover;
    // @ts-expect-error TS(2339): Property 'clearColorCover' does not exist on type ... Remove this comment to see the full error message
    this.prototype.clearColorCover = clearColorCover;
    this.prototype.renderCover = renderCover;
    // @ts-expect-error TS(2339): Property 'clearFullCover' does not exist on type '... Remove this comment to see the full error message
    this.prototype.clearFullCover = clearFullCover;
    // @ts-expect-error TS(2339): Property 'renderFullCover' does not exist on type ... Remove this comment to see the full error message
    this.prototype.renderFullCover = renderFullCover;
    this.prototype.getFullCoverStylesForInitialRender =
      getFullCoverStylesForInitialRender;
    // @ts-expect-error TS(2339): Property 'renderPluginCover' does not exist on typ... Remove this comment to see the full error message
    this.prototype.renderPluginCover = renderPluginCover;
    // @ts-expect-error TS(2339): Property 'getBadgesHtml' does not exist on type 'C... Remove this comment to see the full error message
    this.prototype.getBadgesHtml = getBadgesHtml;
    this.prototype.renderBadges = renderBadges;
    // @ts-expect-error TS(2339): Property 'updateDateBadges' does not exist on type... Remove this comment to see the full error message
    this.prototype.updateDateBadges = updateDateBadges;
    // @ts-expect-error TS(2339): Property 'updateDueDate' does not exist on type 'C... Remove this comment to see the full error message
    this.prototype.updateDueDate = updateDueDate;
    // @ts-expect-error TS(2339): Property 'updateCheckItemsEarliestDue' does not ex... Remove this comment to see the full error message
    this.prototype.updateCheckItemsEarliestDue = updateCheckItemsEarliestDue;
    // @ts-expect-error TS(2339): Property 'toggleDueDateComplete' does not exist on... Remove this comment to see the full error message
    this.prototype.toggleDueDateComplete = toggleDueDateComplete;
    // @ts-expect-error TS(2339): Property 'updateBadges' does not exist on type 'Ca... Remove this comment to see the full error message
    this.prototype.updateBadges = updateBadges;
    this.prototype.renderMembers = renderMembers;
    this.prototype.labelsData = labelsData;
    this.prototype.renderLabels = renderLabels;

    this.prototype.isOnBoardTemplate = isOnBoardTemplate;

    this.prototype.addNewStickerToList = addNewStickerToList;

    // @ts-expect-error TS(2339): Property 'showStickers' does not exist on type 'Ca... Remove this comment to see the full error message
    this.prototype.showStickers = showStickers;

    this.prototype.renderStickers = renderStickers;

    this.prototype.renderName = renderName;

    this.prototype.renderCustomFieldItems = renderCustomFieldItems;

    this.prototype.renderPluginBadges = renderPluginBadges;

    this.prototype.showCover = showCover;

    this.prototype.renderDueComplete = renderDueComplete;

    this.prototype.renderPowerUpEffects = renderPowerUpEffects;

    this.prototype.openQuickCardEditor = openQuickCardEditor;

    // @ts-expect-error TS(2339): Property 'moveToCalendarDay' does not exist on typ... Remove this comment to see the full error message
    this.prototype.moveToCalendarDay = moveToCalendarDay;

    // @ts-expect-error TS(2339): Property 'moveInCalendarDay' does not exist on typ... Remove this comment to see the full error message
    this.prototype.moveInCalendarDay = moveInCalendarDay;

    // @ts-expect-error TS(2339): Property 'moveTo' does not exist on type 'CardView... Remove this comment to see the full error message
    this.prototype.moveTo = moveTo;

    // @ts-expect-error TS(2339): Property 'moveIn' does not exist on type 'CardView... Remove this comment to see the full error message
    this.prototype.moveIn = moveIn;

    // @ts-expect-error TS(2339): Property 'dragenter' does not exist on type 'CardV... Remove this comment to see the full error message
    this.prototype.dragenter = dragenter;

    // @ts-expect-error TS(2339): Property 'dragleave' does not exist on type 'CardV... Remove this comment to see the full error message
    this.prototype.dragleave = dragleave;

    // @ts-expect-error TS(2339): Property 'dropFiles' does not exist on type 'CardV... Remove this comment to see the full error message
    this.prototype.dropFiles = dropFiles;

    // @ts-expect-error TS(2339): Property 'dropUrl' does not exist on type 'CardVie... Remove this comment to see the full error message
    this.prototype.dropUrl = dropUrl;

    this.prototype.removeNotificationIconBadge = removeNotificationIconBadge;

    this.prototype.removeSubscribedIconBadge = removeSubscribedIconBadge;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(options: any) {
    super(options);
    this.onShortcut = this.onShortcut.bind(this);

    // This prevents users from holding shortcuts and spamming the API and tracking
    const keypressThrottleWaitMs = 500;
    this.throttledJoin = this.throttle(this.onJoin, keypressThrottleWaitMs);
    this.throttledClose = this.throttle(this.onClose, keypressThrottleWaitMs);
    this.throttledMoveToNextList = this.throttle(
      this.onMoveToNextList,
      keypressThrottleWaitMs,
    );
    this.throttledMoveToPrevList = this.throttle(
      this.onMoveToPrevList,
      keypressThrottleWaitMs,
    );
    this.throttledSubscribe = this.throttle(
      this.onSubscribe,
      keypressThrottleWaitMs,
    );
    this.throttledVote = this.throttle(this.onVote, keypressThrottleWaitMs);
  }

  className() {
    const baseClassName = this.lazyRenderCard
      ? 'list-card js-member-droppable js-out-of-viewport'
      : 'list-card js-member-droppable';

    if (
      this.model.getBoard()?.getPref('cardCovers') &&
      this.model.get('cover') != null
    ) {
      const {
        size,
        brightness,
        color,
        idAttachment,
        idUploadedBackground,
        idPlugin,
      } = this.model.get('cover');
      if (
        (idAttachment || idUploadedBackground || color || idPlugin) &&
        size === 'full' &&
        this.shouldRenderFullCover()
      ) {
        const brightnessDarkClass =
          brightness === 'dark' ? 'full-cover-list-card-dark' : '';
        const colorCoverClass = color
          ? `color-card-cover color-card-cover-${color} color-blind-pattern-${color}`
          : '';
        return `${baseClassName} full-cover-list-card ${brightnessDarkClass} ${colorCoverClass}`;
      }
    }

    return baseClassName;
  }

  attributes() {
    if (
      this.model.getBoard()?.getPref('cardCovers') &&
      this.model.get('cover') != null
    ) {
      const { size, idAttachment, idUploadedBackground, color, idPlugin } =
        this.model.get('cover');

      if (
        (idAttachment || idUploadedBackground || color || idPlugin) &&
        size === 'full' &&
        this.shouldRenderFullCover()
      ) {
        const style = this.getFullCoverStylesForInitialRender();
        if (style != null) {
          return { style };
        }
      }
    }

    return {};
  }

  initialize() {
    for (const opt of [
      'filterDeactivated',
      'applyBoardCardFilter',
      'trackApdex',
    ]) {
      if (this.options[opt] != null) {
        // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        this[opt] = this.options[opt];
      }
    }

    const board = this.model.getBoard();

    this.makeDebouncedMethods(
      'render',
      'renderName',
      'renderCover',
      'renderFiltered',
      'renderPowerUpEffects',
      'renderStickers',
      'renderBadges',
      'renderDueComplete',
      'renderCustomFieldItems',
      'updateDateBadges',
      'updateBadges',
    );

    this.listenTo(this.model, {
      'change:cardRole': this.render,
      'change:id': this.render,
      'change:name': () => {
        if (this.model.get('cardRole')) {
          this.render();
        } else {
          this.renderNameDebounced();
        }
      },
      'change:idAttachmentCover change:cover': this.renderCoverDebounced,
      'change:name change:labels change:idLabels change:due change:start change:dueComplete':
        this.renderFilteredDebounced,
      'change:due change:start change:badges':
        this.updateRenderIntervalSubscription,
      'change:dueComplete': this.renderDueComplete,
      'change:dateLastActivity': () => {
        this.renderCoverDebounced();
        return this.renderPowerUpEffectsDebounced();
      },
      'change:due change:start change:subscribed change:isTemplate':
        this.renderBadgesDebounced,
      'change:badges': this.updateBadgesDebounced,
      keyboardMove: this.scrollIntoView,
    });

    this.listenTo(
      this.model,
      'change:name change:description change:cover change:labels change:idLabels change:due change:start change:badges',
      this.renderNameDebounced,
    );

    this.listenTo(
      this.model.customFieldItemList,
      'add remove reset change',
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.frameDebounce(function (this: any) {
        this.renderCustomFieldItems();
        this.renderName();
        return this.renderFiltered();
      }),
    );

    this.listenTo(
      this.modelCache,
      'add:Notification remove:Notification change:Notification',
      this.renderBadgesDebounced,
    );

    this.listenTo(
      this.model.memberList,
      'change:initials change:avatarUrl change:fullName change:username',
      this.renderMembers,
    );

    // Don't attach two listeners to the same event! Single listener, 2 function calls
    this.listenTo(
      this.model.memberList,
      'add remove reset',
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.frameDebounce(function (this: any) {
        this.renderMembers();
        this.renderName();
        return this.renderFiltered();
      }),
    );

    this.listenTo(this.model.stickerList, {
      'add remove reset change sort': this.renderStickersDebounced,
    });

    this.listenTo(
      board,
      'change:powerUps change:prefs.cardAging',
      this.renderPowerUpEffectsDebounced,
    );
    this.listenTo(board.filter, 'change', this.renderFilteredDebounced);
    // Possible for a user to become deactivated
    this.listenTo(board, 'change:memberships', this.renderMembers);
    this.listenTo(board, 'change:prefs.hideVotes', this.renderBadgesDebounced);
    this.listenTo(board, 'change:prefs.cardCovers', () => {
      this.renderCoverDebounced();

      if (this.model.get('cardRole') === 'link') {
        this.render();
      }
    });

    this.listenTo(
      board.customFieldList,
      'add remove reset change',
      this.renderCustomFieldItemsDebounced,
    );

    this.listenTo(board.boardPluginList, 'add remove reset change', () => {
      this.renderCustomFieldItemsDebounced();
      return this.renderBadgesDebounced();
    });

    this.listenTo(
      board.viewState,
      'active-card-changed',
      this.renderActiveState,
    );

    this.listenTo(board, 'permChange', this.render);

    // This is just here in case you're dragging a member somewhere before
    // we've managed to hook droppable. It won't work all the time; it's
    // just another cheap chance for us to get it right.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.listenTo(this, 'mouseEnterCardView', function (this: any) {
      return enqueueDroppable(this);
    });

    this.updateRenderIntervalSubscription();

    // use explicit false for lazy card so that newly added cards, dragged cards, etc
    // are not lazy rendered
    this.isObserving = false;
    this.lazyRenderCard = this.options.renderFullCard === false;
    this.hasRenderedFull = false;

    this.observer = new IntersectionObserver((entries) => {
      if (entries.some(({ isIntersecting }) => isIntersecting)) {
        // avoid layout thrashing, check for class first
        if (this.$el.hasClass('js-out-of-viewport')) {
          this.$el.removeClass('js-out-of-viewport');
        }

        if (!this.hasRenderedFull) {
          this.lazyRenderCard = false;
          this.render();
        }

        // we only need to refreshSortables if we're sorting at this point
        if (DragSort.sorting && DragSort.isScrolling) {
          // when we're scrolling, it will stutter in a long list when refreshing sortables
          // so enqueue this instead
          enqueueRefreshSortable(this);
        }
      } else {
        this.$el.addClass('js-out-of-viewport');
      }
    });

    // For really expensive stuff, defer it here
    // @ts-expect-error TS(2345): Argument of type '() => void' is not assignable to... Remove this comment to see the full error message
    this.whenIdle(`initialize_pluginsChangeSignal_${this.cid}`, () => {
      // this subscription takes about 0.5ms per card. So 500 ms for 1000 cards. We can do that work later
      this.subscribe(pluginsChangedSignal(board, this.model), () => {
        this.renderCoverDebounced();
        return this.renderPowerUpEffectsDebounced();
      });
    });
  }

  shouldRenderFullCover() {
    return true;
  }

  renderActiveState() {
    // Don't ask me. This was here before. Should never happen, but who knows?
    if (this.$el == null) {
      return;
    }

    const isActive = this.model
      .getBoard()
      ?.viewState.isCardSelected(this.model);
    this.$el.toggleClass('active-card', isActive);

    if (isActive) {
      PasteInput.addHandler(this, { scope: 'card' });
      registerShortcutHandler(this.onShortcut, { scope: Scope.Card });
    } else {
      PasteInput.removeHandler(this);
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 2.
      unregisterShortcutHandler(this.onShortcut, { scope: Scope.Card });
    }
  }

  removeLabels() {
    const $reactRoot = $('.js-list-card-front-labels-container', this.$el);
    if ($reactRoot[0] && $reactRoot.find('.js-react-root').length) {
      return ReactDOM.unmountComponentAtNode($reactRoot[0]);
    }
  }

  remove() {
    this.observer.disconnect();
    unregisterShortcutHandler(this.onShortcut);
    this.removeLabels();
    this.removeNotificationIconBadge();
    this.removeSubscribedIconBadge();
    return super.remove(...arguments);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClose(event: any, sendShortcutEvent: any, editable: any, callback: any) {
    if (editable) {
      const traceId = Analytics.startTask({
        taskName: 'edit-card/closed',
        source: 'cardView',
      });

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.model.close(traceId, (err: any, card: any) => {
        if (err) {
          throw Analytics.taskFailed({
            taskName: 'edit-card/closed',
            traceId,
            source: 'cardView',
            error: err,
          });
        } else {
          Analytics.sendUpdatedCardFieldEvent({
            field: 'closed',
            source: 'cardView',
            containers: {
              card: { id: card.id },
              board: { id: card.idBoard },
              list: { id: card.idList },
            },
            attributes: {
              taskId: traceId,
            },
          });
          Analytics.taskSucceeded({
            taskName: 'edit-card/closed',
            traceId,
            source: 'cardView',
          });
        }
      });

      event.preventDefault();
      sendShortcutEvent('archiveCardShortcut');
      if (callback) {
        callback();
      }
    }
  }

  onMoveToNextList(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    event: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    key: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    sendShortcutEvent: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    editable: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onCalendar: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    callback: any,
  ) {
    if (editable && !onCalendar) {
      this.model.moveToNextList(
        key === Key.AngleRight ? 'top' : 'bottom',
        callback,
      );
      event.preventDefault();
      sendShortcutEvent('moveToNextListShortcut');
    }
  }

  onMoveToPrevList(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    event: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    key: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    sendShortcutEvent: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    editable: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onCalendar: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    callback: any,
  ) {
    if (editable && !onCalendar) {
      this.model.moveToPrevList(
        key === Key.AngleLeft ? 'top' : 'bottom',
        callback,
      );
      event.preventDefault();
      sendShortcutEvent('moveToPreviousListShortcut');
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleClick(e: any) {
    const cardRole = this.model.getCardRole();

    if (!cardRole) {
      this.showDetail(e);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSubscribe(event: any, sendShortcutEvent: any, loggedIn: any) {
    if (loggedIn && !this.isOnBoardTemplate()) {
      const traceId = Analytics.startTask({
        taskName: 'edit-card/subscribed',
        source: 'cardView',
      });
      const subscribed = this.model.get('subscribed');
      this.model.subscribeWithTracing(
        !subscribed,
        traceId,
        tracingCallback(
          {
            taskName: 'edit-card/subscribed',
            source: 'cardView',
            traceId,
          },
          (_err, response) => {
            if (response) {
              Analytics.sendUpdatedCardFieldEvent({
                field: 'subscribed',
                source: 'cardView',
                containers: {
                  card: { id: response.id },
                  board: { id: response.idBoard },
                  list: { id: response.idList },
                },
                attributes: {
                  taskId: traceId,
                },
              });
            }
          },
        ),
      );
      event.preventDefault();
      sendShortcutEvent('subscribeShortcut', {
        toggleValue: subscribed ? 'unsubscribe' : 'subscribe',
      });
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onJoin(event: any, sendShortcutEvent: any, editable: any) {
    const board = this.model.getBoard();
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const isOnBoardTemplate = this.isOnBoardTemplate();
    if (
      editable &&
      !isOnBoardTemplate &&
      (board.hasActiveMembership(Auth.me()) ||
        board.isEditableByTeamMemberAndIsNotABoardMember())
    ) {
      if (board.isEditableByTeamMemberAndIsNotABoardMember()) {
        board.optimisticJoinBoard();
      }
      const source = 'cardView';
      const traceId = Analytics.startTask({
        taskName: 'edit-card/idMembers',
        source,
      });

      this.model.toggleMemberWithTracing(
        Auth.myId(),
        { traceId },
        tracingCallback(
          {
            taskName: 'edit-card/idMembers',
            traceId,
            source,
          },
          (_err, res) => {
            if (res) {
              Analytics.sendUpdatedCardFieldEvent({
                field: 'idMembers',
                source,
                containers: {
                  card: { id: this.model.id },
                  board: { id: this.model.get('idBoard') },
                  list: { id: this.model.get('idList') },
                },
                attributes: {
                  taskId: traceId,
                  changeType: 'join',
                },
              });
            }
          },
        ),
      );
    }

    event.preventDefault();
    sendShortcutEvent('assignSelfShortcut', {
      shortcutKey: 'Space',
      toggleValue: this.model.hasMember(Auth.myId()) ? 'add' : 'remove',
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onVote(event: any, loggedIn: any, isTemplate: any, sendShortcutEvent: any) {
    if (loggedIn && !isTemplate && this.model.getBoard().canVote(Auth.me())) {
      this.model.toggleVote();
      event.preventDefault();
      sendShortcutEvent('voteShortcut', {
        toggleValue: this.model.voted() ? 'vote' : 'unvote',
      });
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onShortcut(event: any) {
    if (Controller.showingBoardOverlay()) {
      return;
    }

    const loggedIn = Auth.isLoggedIn();
    const editable = this.model.editable();
    const isTemplate = !!this.model.get('isTemplate');
    const { onCalendar } = this;
    const key = getKey(event);

    if (
      this.model.getCardRole() &&
      INVALID_SHORTCUTS_FOR_CARDS_WITH_ROLE.includes(key)
    ) {
      return;
    }

    const sendShortcutEvent = (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      shortcutName: any,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      { shortcutKey = key, toggleValue }: any = {},
    ) => {
      Analytics.sendPressedShortcutEvent({
        shortcutName,
        source: 'cardView',
        keyValue: shortcutKey,
        containers: this.model.getAnalyticsContainers(),
        attributes: {
          toggleValue:
            toggleValue !== undefined ? toggleValue.toLowerCase() : undefined,
        },
      });
    };

    switch (key) {
      case Key.Enter:
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        this.showDetail();
        event.preventDefault();
        sendShortcutEvent('openCardShortcut');
        return;

      case Key.e:
        this.openQuickCardEditor();
        event.preventDefault();
        sendShortcutEvent('quickCardEditorShortcut');
        return;

      case Key.t:
        if (isBoardControllerRefactorEnabled()) {
          navigate(`${getCardUrl(this.model)}?editTitle=true`);
        } else {
          Controller.showCardDetail(this.model, {
            runMethod: 'editTitle',
            method: 'via the T shortcut from card front',
          });
        }
        event.preventDefault();
        sendShortcutEvent('openCardAndEditTitleShortcut');
        return;

      case Key.Dash:
        if (isBoardControllerRefactorEnabled()) {
          navigate(`${getCardUrl(this.model)}?showAddChecklist=true`);
        } else {
          Controller.showCardDetail(this.model, {
            runMethod: 'onChecklistShortcut',
            method: 'via the dash shortcut from card front',
          });
        }
        event.preventDefault();
        sendShortcutEvent('addChecklistShortcut');
        return;

      case Key.d:
        if (editable && !isTemplate) {
          this.showDateRangePicker();

          event.preventDefault();
          sendShortcutEvent('dueDatesShortcut');
        }
        return;

      case Key.l:
        if (editable) {
          toggleLabelsPopover({
            idCard: this.model.id,
            source: 'cardView',
            // @ts-expect-error TS(2322): Type 'HTMLElement | null' is not assignable to typ... Remove this comment to see the full error message
            triggerElement: this.el.querySelector('.js-card-menu'),
          });
          event.preventDefault();
          sendShortcutEvent('editLabelsShortcut');
        }
        return;

      case Key.Zero:
      case Key.One:
      case Key.Two:
      case Key.Three:
      case Key.Four:
      case Key.Five:
      case Key.Six:
      case Key.Seven:
      case Key.Eight:
      case Key.Nine: {
        if (editable) {
          let hasUniqueLabel = true;
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const fxNoUniqueLabel = (color: any) => {
            hasUniqueLabel = false;
            toggleLabelsPopover({
              idCard: this.model.id,
              source: 'cardView',
              // @ts-expect-error TS(2322): Type 'HTMLElement | null' is not assignable to typ... Remove this comment to see the full error message
              triggerElement: this.el.querySelector('.js-card-menu'),
              hideOnSelect: true,
              initialSearchQuery: formatLabelColor(color),
            });
            return;
          };
          LabelKeyHelper.setLabelFromKey(key, this.model, fxNoUniqueLabel);
          event.preventDefault();

          let toggleValue = 'showLabelsPopover';
          if (hasUniqueLabel) {
            const color = LabelKeyHelper.colorForKey(key);
            toggleValue = this.model.hasLabel(color) ? 'add' : 'remove';
          }
          sendShortcutEvent('toggleLabelShortcut', { toggleValue });
        }
        return;
      }

      case Key.a:
      case Key.m:
        if (editable && !this.isOnBoardTemplate()) {
          // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
          this.showPopOver(CardMemberSelectView);
          event.preventDefault();
          sendShortcutEvent('assignMembersShortcut');
        }
        return;

      case Key.Space:
        event.preventDefault();
        this.throttledJoin(event, sendShortcutEvent, editable);
        return;

      case Key.c:
        this.throttledClose(event, sendShortcutEvent, editable, () => {
          const dismissFlag = showFlag({
            id: 'card-archived',
            title: formatShortcuts('card-archived'),
            appearance: 'normal',
            msTimeout: 8000,
            actions: [
              {
                content: formatShortcuts('undo'),
                onClick: () => {
                  undoAction({
                    source: getScreenFromUrl(),
                    idCard: this.model.id,
                  });
                  dismissFlag();
                },
                type: 'button',
              },
            ],
          });
        });
        return;

      case Key.AngleRight:
      case Key.Period:
        this.throttledMoveToNextList(
          event,
          key,
          sendShortcutEvent,
          editable,
          onCalendar,
          () => {
            const dismissFlag = showFlag({
              id: 'card-moved-right',
              title: formatShortcuts('card-moved-right'),
              appearance: 'normal',
              msTimeout: 8000,
              actions: [
                {
                  content: formatShortcuts('undo'),
                  onClick: () => {
                    undoAction({
                      source: getScreenFromUrl(),
                      idCard: this.model.id,
                    });
                    dismissFlag();
                  },
                  type: 'button',
                },
              ],
            });
          },
        );
        return;

      case Key.AngleLeft:
      case Key.Comma:
        this.throttledMoveToPrevList(
          event,
          key,
          sendShortcutEvent,
          editable,
          onCalendar,
          () => {
            const dismissFlag = showFlag({
              id: 'card-moved-left',
              title: formatShortcuts('card-moved-left'),
              appearance: 'normal',
              msTimeout: 8000,
              actions: [
                {
                  content: formatShortcuts('undo'),
                  onClick: () => {
                    undoAction({
                      source: getScreenFromUrl(),
                      idCard: this.model.id,
                    });
                    dismissFlag();
                  },
                  type: 'button',
                },
              ],
            });
          },
        );
        return;

      case Key.v:
        this.throttledVote(event, loggedIn, isTemplate, sendShortcutEvent);
        return;

      case Key.s:
        this.throttledSubscribe(event, sendShortcutEvent, loggedIn);
        return;

      case Key.r:
        if (editable) {
          event.preventDefault();
          return this.waitForId(this.model, () => {
            repeatAction({
              source: 'cardView',
              idBoard: this.model.getBoard().id,
              idCard: this.model.id,
            });
            sendShortcutEvent('repeatActionShortcut');
          });
        }
        return;

      default:
        return;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showPopOver(viewClass: any, options: any) {
    if (options == null) {
      options = {};
    }
    return PopOver.toggle({
      elem: $('.js-card-menu', this.$el),
      view: viewClass,
      options: {
        model: this.model,
        hideOnSelect: true,
        ...options,
      },
    });
  }

  // Use this to pop open the date range picker from outside the context
  // of clicking a button. E.g. keyboard shortcut.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showDateRangePicker = function (this: any) {
    const elem = $('.js-card-menu', this.$el);
    if (elem) {
      return PopOver.toggle({
        elem,
        getViewTitle: () => format('dates'),
        keepEdits: true,
        reactElement: (
          <LazyCardDateRangePicker
            due={this.model.get('due')}
            start={this.model.get('start')}
            dueReminder={this.model.get('dueReminder')}
            // eslint-disable-next-line react/jsx-no-bind
            hidePopover={() => PopOver.hide()}
            idCard={this.model.id}
            idBoard={this.model.getBoard()?.id}
            idOrg={this.model.getBoard()?.get('idOrganization')}
          />
        ),
      });
    }
  };

  render() {
    this.el.setAttribute('data-testid', CardFrontTestIds.TrelloCard);
    if (this.lazyRenderCard) {
      this.renderMinimalCard();
    } else {
      const cardRole = this.model.getCardRole();
      const name = this.model.get('name');

      this.unmountReactCard?.();
      this.renderFull();

      if (cardRole === 'separator') {
        this.unmountReactCard = renderComponent(
          <SeparatorCard
            // eslint-disable-next-line react/jsx-no-bind
            deprecated_openEditor={(e) => {
              e.preventDefault();
              this.openQuickCardEditor();
            }}
            deprecated_isEditable={this.model.editable()}
            analyticsContainers={this.model.getAnalyticsContainers()}
          />,
          this.el,
        );
      } else if (cardRole === 'board') {
        this.unmountReactCard = renderComponent(
          <BoardCard
            // eslint-disable-next-line react/jsx-no-bind
            deprecated_openEditor={(e) => {
              e.preventDefault();
              this.openQuickCardEditor();
            }}
            boardUrl={name}
            deprecated_isEditable={this.model.editable()}
            analyticsContainers={this.model.getAnalyticsContainers()}
          />,
          this.el,
        );
      } else if (cardRole === 'link') {
        const cardCoversPrefs = this.model.getBoard()?.getPref('cardCovers');

        this.unmountReactCard = renderComponent(
          <CardIdProvider value={this.model.id}>
            <LazyLinkCard
              idCard={this.model.id}
              // eslint-disable-next-line react/jsx-no-bind
              deprecated_openEditor={(e) => {
                e.preventDefault();
                this.openQuickCardEditor();
              }}
              url={name}
              hideCover={!cardCoversPrefs}
              deprecated_isEditable={
                this.model.editable() && !this.options.quickEditHidden
              }
              analyticsContainers={this.model.getAnalyticsContainers()}
            />
          </CardIdProvider>,
          this.el,
        );
      }
    }

    if (!this.isObserving) {
      this.observer.observe(this.el);
    }

    return this;
  }

  renderFull() {
    const data: CardAttributes & {
      showCover?: boolean;
      showEditor?: boolean;
      hasStickers?: boolean;
      labels?: object[];
      canAssign?: boolean;
      members?: MemberAttributes[];
      attachmentCoverUrl?: string;
      hideCover?: boolean;
      hasCover?: boolean;
    } = this.model.toJSON();
    this.hasRenderedFull = true;

    data.showCover = this.showCover();
    data.showEditor = this.model.editable() && !this.options.hideMenu;

    if (this.model.hasStickers()) {
      data.hasStickers = true;
    }

    // render this stuff upfront so we don't have to thrash the layout again.
    data.labels = this.labelsData();

    const board = this.model.getBoard();

    // Whether to make card members draggable
    data.canAssign = board.editable();

    data.members = [];
    for (let i = this.model.memberList.models.length - 1; i >= 0; i--) {
      const member = this.model.memberList.models[i];
      const memberData: MemberAttributes & {
        isVirtual?: boolean;
        isDeactivated?: boolean;
      } = member.toJSON();
      memberData.isVirtual =
        board.getOrganization()?.isVirtual(member) || board.isVirtual(member);
      memberData.isDeactivated = board.isDeactivated(member);

      data.members.push(memberData);
    }

    // Needed to pre-render covers to reduce flickering when the card is moved around.
    data.cover = this.model.get('cover');

    if (this.model.get('idAttachmentCover')) {
      data.attachmentCoverUrl = this.model.attachmentList
        .get(this.model.get('idAttachmentCover'))
        ?.get('url');
    }
    data.hideCover =
      !this.model.getBoard().getPref('cardCovers') || this.onCalendar;
    data.hasCover = this.model.hasCover();

    // add classes before adding to the DOM to prevent layout thrashing.
    this.$el.toggleClass('js-archive-card', this.model.get('closed'));

    if (this.showCover() && this.model.hasCover()) {
      this.$el.addClass('is-covered');
    }

    if (this.model.hasStickers()) {
      this.$el.addClass('is-stickered');
    }

    this.$el.html(CardInListTemplate(data));

    this.renderName();
    this.renderBadges();
    this.renderCustomFieldItems();
    this.renderDueComplete();
    this.renderLabels();

    // make sure cards stay active when re-rendered
    this.renderPluginBadges();
    this.renderActiveState();
    this.renderCover();
    this.renderStickers();
    this.renderPowerUpEffects();
    this.renderMembers();
    this.waitForId(this.model, () => this.renderLink());
    // Hooking droppable is expensive. Use a worker queue.
    this._droppableHookedSinceRender = false;
    enqueueDroppable(this);
    this.renderFiltered();

    return this;
  }

  renderMinimalCard() {
    // use safe to prevent xss on user generated content, since we are
    // manually making a minimal card here
    this.$el.html(`
      <div class="list-card-details">
        <span class="list-card-title">${safe(
          this.model.get('name') || '',
        )}</span>
      </div>
    `);
    this.renderFiltered();
    return this;
  }

  // Hook a jquery.ui.droppable for dropping members from the sidebar
  // This is inordinately expensive to run, because of the width and height
  // calculations done in 'droppable', see the HOOK_DROPPABLE_QUEUE above
  hookDroppable() {
    if (isTouch()) {
      return;
    }
    // It's possible that we've been removed from the DOM/destroyed
    // If that's the case, then just abort
    if (this.$el == null) {
      return;
    }

    // We're using an event handler AND a queue, so only hook once per render
    if (this._droppableHookedSinceRender) {
      return;
    }

    this._droppableHookedSinceRender = true;

    if (!isTouch()) {
      const getFrame = this.throttle(
        () =>
          // @ts-expect-error TS(2531): Object is possibly 'null'.
          window.document
            .querySelector('.board-canvas')
            .getBoundingClientRect(),
        100,
        { trailing: false },
      );
      // @ts-expect-error TS(2339): Property 'droppable' does not exist on type 'JQuer... Remove this comment to see the full error message
      this.$el.droppable({
        refreshPositions: true,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        inBounds(e: any) {
          // This is used to make sure we don't drop onto cards through the
          // sidebar. We have to recalculate this in case the user toggles
          // the sidebar with the keyboard shortcut.
          const frame = getFrame();
          return (
            frame.left <= e.pageX &&
            e.pageX < frame.right &&
            frame.top <= e.pageY &&
            e.pageY < frame.bottom
          );
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        accept: (el: any) => {
          if (
            el.is('.js-list-draggable-board-members .member') ||
            el.is('.js-list-draggable-card-members .member')
          ) {
            return true;
          }
          if (el.is('.js-draggable-sticker') && !this.model.getCardRole()) {
            return !isOverLimit(
              'stickers',
              'perCard',
              this.model?.get('limits'),
            );
          }
          return false;
        },
        hoverClass: 'active-card',
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        drop: (_e: any, ui: any) => {
          if (ui.draggable.hasClass('member')) {
            // Dragging a board header avatar has 'id' but dragging a card avatar has 'idmem'
            const draggedMemberId =
              ui.draggable.data('id') ?? ui.draggable.data('idmem');
            // Add attribute with destination card's id to ui helper to read from the draggable's stop event where we remove member from source card
            if (draggedMemberId === ui.draggable.data('idmem')) {
              ui.helper.data('droppedOnCard', { id: this.model.id });
            }

            const isAlreadyMember = this.model.memberList.detect(
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              (member: any) => member.id === draggedMemberId,
            );

            if (!isAlreadyMember) {
              const source = 'boardScreen';
              const traceId = Analytics.startTask({
                taskName: 'edit-card/idMembers',
                source,
              });

              this.model.addMemberWithTracing(
                draggedMemberId,
                traceId,
                tracingCallback(
                  {
                    taskName: 'edit-card/idMembers',
                    traceId,
                    source,
                  },
                  (_err, res) => {
                    if (res) {
                      Analytics.sendUpdatedCardFieldEvent({
                        field: 'idMembers',
                        source,
                        containers: {
                          card: { id: this.model.id },
                          board: { id: this.model.get('idBoard') },
                          list: { id: this.model.get('idList') },
                        },
                        attributes: {
                          taskId: traceId,
                          changeType: 'add member',
                        },
                      });
                    }
                  },
                ),
              );
            }
          } else if (ui.draggable.hasClass('js-draggable-sticker')) {
            let borderLeftWidth, borderRightWidth, rotate, top;
            const sticker = ui.draggable.data('sticker');

            const borderTopWidth = (borderLeftWidth = borderRightWidth = 1);

            // Figure out where the sticker area would be, if the card had a
            // sticker area
            const stickerOffset = ui.helper.offset();
            const targetOffset = {
              // @ts-expect-error TS(2532): Object is possibly 'undefined'.
              top: this.$el.offset().top + borderTopWidth,
              // @ts-expect-error TS(2532): Object is possibly 'undefined'.
              left: this.$el.offset().left + borderLeftWidth,
            };

            const targetWidth =
              // @ts-expect-error TS(2532): Object is possibly 'undefined'.
              this.$el.outerWidth() - borderLeftWidth - borderRightWidth;

            const offsetLeft = stickerOffset.left - targetOffset.left;
            const offsetTop = stickerOffset.top - targetOffset.top;

            const left = (offsetLeft / targetWidth) * 100;
            const stickerAreaHeight = $('.js-card-stickers', this.$el).height();

            if (
              this.$el.hasClass('is-stickered') ||
              this.$el.hasClass('is-covered')
            ) {
              // @ts-expect-error TS(2532): Object is possibly 'undefined'.
              top = (offsetTop / stickerAreaHeight) * 100;
            } else {
              // This card doesn't have anything on it yet; it's unlikely that
              // you're trying to place it at an exact vertical position, and
              // putting it right where you drop it will put part of the sticker
              // off of the card
              top = 0;
            }

            // if the user tries to put the sticker below the valid area, move
            // it as far down as possible
            // @ts-expect-error TS(2532): Object is possibly 'undefined'.
            if (top > stickerAreaHeight) {
              top = stickerAreaHeight;
            }

            const transformMatrix = Util.getElemTransformMatrix(
              ui.helper.find('.sticker-select-fixed'),
            );
            if (transformMatrix != null) {
              rotate = Util.getMatrixDegrees(transformMatrix) % 360;
            } else {
              rotate = 0;
            }

            this.addNewStickerToList(sticker, left, top, rotate);
          }
        },
      });
    }
  }

  renderLink() {
    const cardRole = this.model.getCardRole();
    if (cardRole) return;

    const url = getCardUrl(this.model);

    this.$el.attr('href', url);

    return this;
  }

  isVisible() {
    if (this.options.dontFilter != null) {
      return;
    }

    if (this._visible == null) {
      this._visible = true;
    }
    const board = this.model.getBoard();
    const routeId = getRouteIdFromPathname(window.location.pathname);
    const isBoardRoute = [RouteId.BOARD, RouteId.CARD].includes(routeId);

    // You can see the card if you aren't looking at it's board, or it matches
    // the filter of the board you're looking at
    return (
      board == null ||
      !isBoardRoute ||
      !this.applyBoardCardFilter ||
      board.filter.satisfiesFilter(this.model)
    );
  }

  renderFiltered() {
    const visible = this.isVisible();
    if (this._visible !== visible) {
      // We set the height in order to help out dragsort.
      // http://stackoverflow.com/questions/9440664
      this.$el.toggleClass('hide', !visible).height(visible ? '' : 0);
      this._visible = visible;
    }
    return this;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showDetail(e: any) {
    if (e && (e.ctrlKey || e.metaKey || e.shiftKey)) {
      return;
    }

    // Stop the event so we don't end up running the click handler for the URL
    // as well.
    // This must run first if this event fires with no modifier keys.
    // otherwise it exposes a firefox bug where dropping the card
    // can cause the card detail to open
    stopPropagationAndPreventDefault(e);

    // We don't want to open the card detail if we're in the middle of
    // dragging a card around; the "click" is probably the member dropping
    // the card
    if (DragSort.sorting) {
      return;
    }

    const tracingAttributes = {
      taskName: 'view-card',
      source: 'boardScreen',
    };

    // @ts-expect-error TS(2345): Argument of type '{ taskName: string; source: stri... Remove this comment to see the full error message
    const traceId = Analytics.startTask(tracingAttributes);

    const onSuccess = () => {
      // @ts-expect-error TS(2345): Argument of type '{ traceId: string; taskName: str... Remove this comment to see the full error message
      Analytics.taskSucceeded({
        ...tracingAttributes,
        traceId,
      });
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onFail = (error: any) => {
      // @ts-expect-error TS(2345): Argument of type '{ traceId: string; error: any; t... Remove this comment to see the full error message
      Analytics.taskFailed({
        ...tracingAttributes,
        traceId,
        error,
      });
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onAbort = (error: any) => {
      // @ts-expect-error TS(2345): Argument of type '{ traceId: string; error: any; t... Remove this comment to see the full error message
      Analytics.taskAborted({
        ...tracingAttributes,
        traceId,
        error,
      });
    };

    if (this.options.trackEvent) {
      // @ts-expect-error TS(2339): Property 'trackEvent' does not exist on type '{}'.
      this.options.trackEvent();
    }

    if (this.trackApdex) {
      Apdex.start({
        task: 'cardFromBoard',
        taskId: this.model.id,
      });
    }

    Controller.showCardDetail(this.model, {
      runMethod: this.model.shouldSuggestDescription()
        ? 'expandDesc'
        : undefined,
      method: 'from card front',
      onSuccess,
      onFail,
      onAbort,
    });

    if (this.trackApdex) {
      return Apdex.stop({
        task: 'cardFromBoard',
        taskId: this.model.id,
      });
    }
  }

  scrollIntoView() {
    // Usually just .scrollIntoView() would do
    // but IE10 scrolls the whole thing to the left
    const board = this.$el.closest('#board');
    const list = this.$el.closest('.js-list');
    const listRect = list[0].getBoundingClientRect();
    const scrollDelta = listRect.left + listRect.width - window.innerWidth;

    this.$el.closest('.js-list-cards').scrollTop(this.$el.position().top);

    if (listRect.left < 0) {
      return board.animate({ scrollLeft: list.position().left }, 150);
    } else if (scrollDelta > 0) {
      return board.animate(
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
        { scrollLeft: board.scrollLeft() + scrollDelta },
        150,
      );
    }
  }

  updateRenderIntervalSubscription() {
    if (
      this.model.get('due') ||
      (this.advancedChecklistsV2Enabled &&
        this.model.get('badges')?.checkItemsEarliestDue)
    ) {
      this.listenTo(Dates, 'renderInterval', this.updateDateBadgesDebounced);
      return;
    }
    return this.stopListening(
      Dates,
      'renderInterval',
      this.updateDateBadgesDebounced,
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openMemberOnCardMenu(e: any) {
    return CardViewHelpers.openMemberOnCardMenu.call(this, e);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openMemberOnAtMention(e: any) {
    return CardViewHelpers.openMemberOnAtMention.call(this, e);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getMemberOnCardHtml(member: any) {
    return CardViewHelpers.getMemberOnCardHtml.call(this, member);
  }
}
CardView.initClass();
export { CardView };
